import React, { useEffect } from 'react'
import { platformTransitionStyle } from '../../../../shared/helpers'
import LogoHeaderTS from '../LogoHeader'
import { KeyTypeEnum } from '../../../../shared/hooks/useKeyDownHandler'
import type { ScrollingTextModalProps } from '../ScrollingTextModal/types'
import { useKeyDown } from '../../../../shared/providers/KeyDownProvider/KeyDownProvider'
import tts from '../../lib/TTS'

function TextModal({
  title,
  content,
  handleDescriptionModal,
}: ScrollingTextModalProps) {
  useEffect(() => {
    tts.stopRead()
    tts.addTextToRead(`${title} .... ${content}`)
  }, [])

  useKeyDown([KeyTypeEnum.Back], () => {
    tts.stop()
    handleDescriptionModal()
  }, {
    stopPropagation: true,
  })

  return (
    <section className="text-modal-container">
      <LogoHeaderTS />
      <div className="text-modal-container__body">
        <h1 className="text-modal-container__title">{title}</h1>
        <div
          className="text-modal-container__content"
          style={{
            transition: platformTransitionStyle('transform 500ms ease-in-out'),
          }}
        >
          {content}
        </div>
      </div>
    </section>
  )
}

export default TextModal
